<template>
  <section v-if="user" class="mainEdit form section">
    <div v-if="editMode" class="rew-containers">
      <ValidationObserver ref="mainEdit" tag="div" class="form__body">
        <div class="row">
          <div class="col-lg-2 offset-xl-1 col-md-3">
            <label
              for="upload-image"
              :class="'upload-image ' + (imageNotValid ? ' div-error ' : '')"
            >
              <div
                v-if="user_data && user_data.photo && !avatarImgLoaded"
                class="file-inner"
              >
                <div class="file-content">
                  <div class="file-title">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5 4H7.5C7.10218 4 6.72064 4.16857 6.43934 4.46863C6.15804 4.76869 6 5.17565 6 5.6V18.4C6 18.8243 6.15804 19.2313 6.43934 19.5314C6.72064 19.8314 7.10218 20 7.5 20H16.5C16.8978 20 17.2794 19.8314 17.5607 19.5314C17.842 19.2313 18 18.8243 18 18.4V8.5L13.5 4Z"
                        fill="#929BAA"
                      />
                      <path
                        d="M13 4.5V8.5C13 8.77614 13.2239 9 13.5 9H17.5"
                        fill="white"
                      />
                    </svg>
                    <span>{{ user_data.photo.name }}</span>
                  </div>
                  <div class="file-size">
                    {{ Math.round(user_data.photo.size / 1024) }}kb
                  </div>
                  <div class="file-loader">
                    <div
                      class="file-loader__bar"
                      :style="
                        'width: ' +
                        (otherUploadPercentage ? otherUploadPercentage : '0') +
                        '%;'
                      "
                    />
                  </div>
                </div>
                <div v-if="otherUploadPercentage == 100" class="file-status">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="8" fill="#29CC44" />
                    <path
                      d="M16 9.33203L10.8571 14.6654L8 11.7563"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div
                v-show="loaderImg"
                class="upload-image__img-container loader-image"
              >
                <SimplePreloader />
              </div>
              <div v-show="imagePreview" class="upload-image__img-container">
                <div class="hover_upload-new">
                  <icon name="edit_class_column" />
                </div>
                <input
                  ref="file"
                  type="file"
                  accept=".png, .jpg, .jpeg, .gif"
                  max-size="2000"
                  class="upload-image__input"
                  @change="selectFile($event)"
                />

                <img
                  class="upload-image__upload-img"
                  :src="imagePreview ? '/storage/' + imagePreview : ''"
                  alt=""
                />
              </div>
              <div v-show="!imagePreview" class="upload-image__zone">
                <input
                  id="upload-image"
                  ref="file"
                  type="file"
                  accept=".png, .jpg, .jpeg, .gif"
                  max-size="2000"
                  class="upload-image__input"
                  @change="selectFile($event)"
                />
                <div class="upload-image__zone-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 17.4444C20 17.857 19.8468 18.2527 19.574 18.5444C19.3012 18.8361 18.9312 19 18.5455 19H5.45455C5.06878 19 4.69881 18.8361 4.42603 18.5444C4.15325 18.2527 4 17.857 4 17.4444V8.88889C4 8.47633 4.15325 8.08067 4.42603 7.78894C4.69881 7.49722 5.06878 7.33333 5.45455 7.33333H8.36364L9.81818 5H14.1818L15.6364 7.33333H18.5455C18.9312 7.33333 19.3012 7.49722 19.574 7.78894C19.8468 8.08067 20 8.47633 20 8.88889V17.4444Z"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="upload-image__zone-title">טען תמונה</div>
                <div class="upload-image__zone-text">
                  גודל הקובץ המרבי<br />
                  mb20 הוא
                </div>
              </div>
              <div v-show="imageNotValid" class="form__field-error">
                {{ imageError }}
              </div>
            </label>
          </div>
          <div class="col-xl-9 col-lg-10 col-md-9">
            <div class="row">
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">שם פרטי</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="שם פרטי"
                    vid="user.name"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                      <!--                                                                        {{ errors[0] }}-->
                    </div>

                    <input
                      v-model="user_data.name"
                      type="text"
                      :class="
                        'form__field-input ' + (errors[0] ? ' error ' : '')
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">שם משפחה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="שם משפחה"
                    vid="user.last_name"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <input
                      v-model="user_data.last_name"
                      type="text"
                      :class="
                        'form__field-input ' + (errors[0] ? ' error ' : '')
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">קטגוריה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="קטגוריה"
                    vid="student.student_status_id"
                    rules="required"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                      <!--                                                                        {{ errors[0] }}-->
                    </div>

                    <Select2
                      v-model="student_data.student_status_id"
                      :options="statuses"
                      :settings="{ language: 'he' }"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">השתייכות ארגונית</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="השתייכות ארגונית"
                    rules="required"
                    vid="student.organization_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.organization_id"
                      :options="organizations"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                  <!--
                                                                                                <select class="form__field-select">
                                                                                                    <option value="משרד הרווחה">משרד הרווחה</option>
                                                                                                </select>
                                    -->
                </div>
              </div>

              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">מסגרת</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="מסגרת"
                    :rules="atLeastOneNotEmpty"
                    vid="user.institutions"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="institutions"
                      v-model="institutions_ids_data"
                      :multiple="false"
                      :openDirection="'bottom'"
                      :class="errors[0] ? ' custom-select-error ' : ''"
                    >
                    </CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">רשות</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="מסגרת"
                    :rules="atLeastOneNotEmpty"
                    vid="user.administrations"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <CustomThreeSelectVue
                      :options="administrations"
                      v-model="district_administrations_ids_data"
                      :openDirection="'bottom'"
                      :class="errors[0] ? ' custom-select-error ' : ''"
                    >
                    </CustomThreeSelectVue>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">קבוצה</div>

                  <ValidationProvider
                    v-slot="{ errors }"
                    name="קבוצה"
                    vid="student.student_group_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.student_group_id"
                      :options="groups"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form__field">
                  <div class="form__field-label">כיתה</div>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="כיתה"
                    vid="student.student_class_id"
                  >
                    <div class="form__field-error">
                      {{ errors[0] }}
                    </div>

                    <Select2
                      v-model="student_data.student_class_id"
                      :options="classes"
                      :class="errors[0] ? ' select-error ' : ''"
                    />
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-lg-4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="כיתה"
                  vid="student.student_class_id"
                >
                  <div v-show="periodNotValid" class="form__field-error">
                    {{ periodError }}
                  </div>

                  <div
                    :class="
                      'form__date-inner ' +
                      (periodNotValid ? ' div-error ' : '')
                    "
                  >
                    <div class="form__field mb-0">
                      <div class="form__field-label">תאריך קליטה</div>
                      <vDatepicker
                        class="datepicker_end"
                        :date="student_data.study_start"
                        :error="errors[0]"
                        border_none="true"
                        icon_none="true"
                        @change="changeStudy_start"
                      />
                    </div>

                    <div class="form__date-inner-sep">-</div>
                    <div class="form__field mb-0">
                      <div class="form__field-label">תאריך סיום צפוי</div>
                      <vDatepicker
                        :date="student_data.study_end"
                        :error="errors[0]"
                        border_none="true"
                        icon_none="true"
                        @change="changeStudy_end"
                      />
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="form__footer d-flex">
              <button class="btn btn--blue btn--static" @click="saveData()">
                שמור שינויים
              </button>
              <button
                class="btn btn--border-grey btn--static"
                @click="changeMode(false)"
              >
                בטל שינויים
              </button>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <div v-else class="student-form py-0">
      <div class="rew-containers">
        <div class="row">
          <div class="col-12 d-md-flex align-items-center">
            <div>
              <the-confirm
                title="אזהרה"
                :is-shown="showDeleteConfirm"
                question=" האם ברצונך להעביר את התלמידים האלה להסרה? (הם יוסרו מכיתות וקבוצות, הסטטוס יעודכן ל״לא סיימו״)."
                @ok="
                  deleteTrigger(true);
                  showDeleteConfirm = false;
                "
                @cancel="showDeleteConfirm = false"
              />
            </div>
            <div class="student-form__controls">
              <div
                v-if="$perm('student.edit', currentUser.campus_id)"
                class="security-select-btn"
                @click="changeMode(true)"
              >
                <div>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.8473 3.1267C14.046 2.92801 14.2819 2.7704 14.5415 2.66287C14.8011 2.55534 15.0793 2.5 15.3603 2.5C15.6413 2.5 15.9195 2.55534 16.1791 2.66287C16.4387 2.7704 16.6746 2.92801 16.8733 3.1267C17.072 3.32538 17.2296 3.56126 17.3371 3.82086C17.4447 4.08045 17.5 4.35869 17.5 4.63968C17.5 4.92066 17.4447 5.1989 17.3371 5.45849C17.2296 5.71809 17.072 5.95397 16.8733 6.15266L6.66069 16.3653L2.5 17.5L3.63473 13.3393L13.8473 3.1267Z"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="redact-text">עריכה</span>
                </div>

                <div class="tooltip bot">עריכה</div>
              </div>

              <div
                class="security-select-wrapper"
                v-click-outside="() => (showSecurityDropdown = false)"
              >
                <button
                  type="button"
                  class="security-select-btn"
                  @click.stop="showSecurityDropdown = !showSecurityDropdown"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 9V5.88889C6 4.85749 6.42143 3.86834 7.17157 3.13903C7.92172 2.40972 8.93913 2 10 2C11.0609 2 12.0783 2.40972 12.8284 3.13903C13.5786 3.86834 14 4.85749 14 5.88889V9M4.55556 9H15.4444C16.3036 9 17 9.73263 17 10.6364V16.3636C17 17.2674 16.3036 18 15.4444 18H4.55556C3.69645 18 3 17.2674 3 16.3636V10.6364C3 9.73263 3.69645 9 4.55556 9Z"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span class="dropdawn-info-text">בטיחות</span>

                  <svg
                    class="dropdown-arrow"
                    :class="{ 'dropdown-arrow--open': showSecurityDropdown }"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.16699 7.5L10.0003 13.3333L15.8337 7.5"
                      stroke="#5A6F95"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <div v-if="showSecurityDropdown" class="security-dropdown-menu">
                  <user-controls
                    :block-user="
                      user.last_block &&
                      user.last_block !== null &&
                      (user.last_block.is_blocked === 1 ||
                        user.last_block.is_blocked === true)
                    "
                    classList="security-menu-controls"
                    @unBlockUser="unBlockUser"
                    @blockUser="blockUser"
                    @changePasswordModal="changePasswordModal = true"
                  />
                  <div
                    class="security-dropdown-item"
                    @click="isSend = true"
                    v-if="showSendLoginCredentials"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.08342 9.58301V3.33301M2.08342 3.33301L10.4167 9.16634L18.7501 3.33301M2.08342 3.33301H18.7501M18.7501 3.33301V15.833H11.2501M1.25 15.833H7.08333M1.25 15.833L3.75008 13.333M1.25 15.833L3.75008 18.333"
                        stroke="#5A6F95"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span class="email-text"> שליחת פרטי התחברות </span>
                  </div>
                  <div
                    v-if="$perm('devices.manage')"
                    class="security-dropdown-item"
                    @click="openDevicesModal"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.333 16.667H6.667M10 13.333V16.667M3.333 3.333h13.334c.92 0 1.666.746 1.666 1.667v6.667c0 .92-.746 1.666-1.666 1.666H3.333c-.92 0-1.666-.746-1.666-1.666V5c0-.92.746-1.667 1.666-1.667z"
                        stroke="#5A6F95"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span class="email-text"> מכשירים מחוברים </span>
                  </div>
                  <!-- Google Calendar - temporarily disabled
                  <div
                    class="security-dropdown-google-calendar"
                    v-click-outside="closeGoogleCalendarDropdown"
                  >
                    <div
                      class="security-dropdown-item"
                      :class="{
                        'security-dropdown-item--google-connected':
                          googleCalendarConnected
                      }"
                      @click.stop="toggleGoogleCalendarDropdown"
                    >
                      <icon
                        name="new-calendar-icon"
                        class="google-calendar-icon"
                        :width="20"
                        :height="20"
                      />
                      <span class="email-text">Google Calendar</span>
                    </div>
                    <div
                      v-if="showGoogleCalendarDropdown"
                      class="
                        protech-dropdown-menu
                        google-calendar-dropdown-menu
                      "
                      @click.stop
                    >
                      <div class="google-calendar-dropdown">
                        <div
                          v-if="googleCalendarEmail"
                          class="google-calendar-dropdown-email"
                        >
                          {{ googleCalendarEmail }}
                        </div>
                        <label
                          class="
                            checkbox
                            not-empty
                            google-calendar-dropdown__option
                          "
                          tabindex="0"
                          @keyup.enter="googleCalendarPermission = 'deny'"
                        >
                          <input
                            v-model="googleCalendarPermission"
                            type="radio"
                            value="deny"
                            class="checkbox__input not-empty"
                          />
                          <div class="checkbox__marker" />
                          <div class="checkbox__text">לא נותן הרשאה</div>
                        </label>
                        <label
                          class="
                            checkbox
                            not-empty
                            google-calendar-dropdown__option
                          "
                          tabindex="0"
                          @keyup.enter="googleCalendarPermission = 'grant'"
                        >
                          <input
                            v-model="googleCalendarPermission"
                            type="radio"
                            value="grant"
                            class="checkbox__input not-empty"
                          />
                          <div class="checkbox__marker" />
                          <div class="checkbox__text">נותן הרשאה</div>
                        </label>
                        <button
                          type="button"
                          class="
                            btn btn--blue btn--static
                            google-calendar-dropdown__save
                          "
                          :disabled="googleCalendarSaving"
                          @click="saveGoogleCalendarPermission"
                        >
                          שמור
                        </button>
                      </div>
                    </div>
                  </div>
                  -->
                  <div
                    v-if="
                      isUserInProptech &&
                      $perm(
                        'security.view_proptech_selfenrollment_link',
                        currentUser.campus_id
                      )
                    "
                    class="protech-add-btn-wrapper security-dropdown-protech"
                    v-click-outside="() => (showProptechDropdown = false)"
                  >
                    <div
                      class="protech-add-btn tooltip-hover"
                      @click.stop="showProptechDropdown = !showProptechDropdown"
                    >
                      <svg
                        class="green-protech"
                        width="72"
                        height="40"
                        viewBox="0 0 72 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="72" height="40" rx="8" fill="#EAFFEE" />
                        <path
                          d="M62 15L52 25L51.375 24.375M42 20L47 25L57 15"
                          stroke="#24B33C"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <mask
                          id="mask0_39379_25050"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="8"
                          y="8"
                          width="24"
                          height="24"
                        >
                          <rect
                            x="8"
                            y="8"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_39379_25050)">
                          <path
                            d="M20 20C19.15 20 18.4375 19.7125 17.8625 19.1375C17.2875 18.5625 17 17.85 17 17C17 16.1667 17.2875 15.4583 17.8625 14.875C18.4375 14.2917 19.15 14 20 14C20.8333 14 21.5417 14.2917 22.125 14.875C22.7083 15.4583 23 16.1667 23 17C23 17.85 22.7083 18.5625 22.125 19.1375C21.5417 19.7125 20.8333 20 20 20ZM20 18C20.2833 18 20.5208 17.9042 20.7125 17.7125C20.9042 17.5208 21 17.2833 21 17C21 16.7167 20.9042 16.4792 20.7125 16.2875C20.5208 16.0958 20.2833 16 20 16C19.7167 16 19.4792 16.0958 19.2875 16.2875C19.0958 16.4792 19 16.7167 19 17C19 17.2833 19.0958 17.5208 19.2875 17.7125C19.4792 17.9042 19.7167 18 20 18ZM14 26V24.1C14 23.75 14.0875 23.4208 14.2625 23.1125C14.4375 22.8042 14.675 22.5583 14.975 22.375C15.7417 21.925 16.5458 21.5833 17.3875 21.35C18.2292 21.1167 19.1 21 20 21C20.9 21 21.7708 21.1167 22.6125 21.35C23.4542 21.5833 24.2583 21.925 25.025 22.375C25.325 22.5583 25.5625 22.8042 25.7375 23.1125C25.9125 23.4208 26 23.75 26 24.1V26H14ZM20 23C19.3167 23 18.65 23.0833 18 23.25C17.35 23.4167 16.7333 23.6667 16.15 24H23.85C23.2667 23.6667 22.65 23.4167 22 23.25C21.35 23.0833 20.6833 23 20 23ZM12 30C11.45 30 10.9792 29.8042 10.5875 29.4125C10.1958 29.0208 10 28.55 10 28V24H12V28H16V30H12ZM10 16V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10H16V12H12V16H10ZM24 30V28H28V24H30V28C30 28.55 29.8042 29.0208 29.4125 29.4125C29.0208 29.8042 28.55 30 28 30H24ZM28 16V12H24V10H28C28.55 10 29.0208 10.1958 29.4125 10.5875C29.8042 10.9792 30 11.45 30 12V16H28Z"
                            fill="#24B33C"
                          />
                        </g>
                      </svg>
                      <div class="tooltip bot">שליחת קישור להעלאת התמונה</div>
                    </div>
                    <div
                      v-if="showProptechDropdown"
                      class="protech-dropdown-menu"
                    >
                      <div
                        class="protech-dropdown-item"
                        @click="sendEnrollmentLink"
                      >
                        <div class="send-block">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2 11.5V4M2 4L12 11L22 4M2 4H22M22 4V19H13M1 19H8M1 19L4 16M1 19L4 22"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>שלח קישור להרשמה עצמית</span>
                        </div>
                      </div>
                      <div class="protech-dropdown-item" @click="loadUserPhoto">
                        <div class="send-block">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 15L3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21L19 21C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19L21 15M17 8L12 3M12 3L7 8M12 3L12 16"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>להעלות תמונה ידנית</span>
                        </div>
                      </div>
                      <div
                        class="protech-dropdown-item"
                        @click="deleteUserFromProptech"
                      >
                        <div class="send-block">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 7.00002H20M8.57143 7.00021V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7.00021M10 11V17M14 11V17M18 7.00021V19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2V7.00021H18Z"
                              stroke="#FD1500"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span class="delete-send-text">
                            מחק נתונים ממערכת זיהוי</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="proptech-texts">זיהוי פנים</div>
                  </div>
                  <div
                    v-if="
                      !isUserInProptech &&
                      $perm(
                        'security.view_proptech_selfenrollment_link',
                        currentUser.campus_id
                      )
                    "
                    class="protech-add-btn-wrapper security-dropdown-protech"
                  >
                    <div
                      class="protech-add-btn"
                      @click="addUserToProptech"
                      title="הוסף למערכת PropTech"
                    >
                      <svg
                        class="orange-protech"
                        width="72"
                        height="40"
                        viewBox="0 0 72 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="72" height="40" rx="8" fill="#FFCD39" />
                        <path
                          d="M43 23L43 27C43 27.5304 43.2107 28.0391 43.5858 28.4142C43.9609 28.7893 44.4696 29 45 29L59 29C59.5304 29 60.0391 28.7893 60.4142 28.4142C60.7893 28.0391 61 27.5304 61 27V23M57 16L52 11M52 11L47 16M52 11L52 24"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <mask
                          id="mask0_39379_25057"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="8"
                          y="8"
                          width="24"
                          height="24"
                        >
                          <rect
                            x="8"
                            y="8"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_39379_25057)">
                          <path
                            d="M20 20C19.15 20 18.4375 19.7125 17.8625 19.1375C17.2875 18.5625 17 17.85 17 17C17 16.1667 17.2875 15.4583 17.8625 14.875C18.4375 14.2917 19.15 14 20 14C20.8333 14 21.5417 14.2917 22.125 14.875C22.7083 15.4583 23 16.1667 23 17C23 17.85 22.7083 18.5625 22.125 19.1375C21.5417 19.7125 20.8333 20 20 20ZM20 18C20.2833 18 20.5208 17.9042 20.7125 17.7125C20.9042 17.5208 21 17.2833 21 17C21 16.7167 20.9042 16.4792 20.7125 16.2875C20.5208 16.0958 20.2833 16 20 16C19.7167 16 19.4792 16.0958 19.2875 16.2875C19.0958 16.4792 19 16.7167 19 17C19 17.2833 19.0958 17.5208 19.2875 17.7125C19.4792 17.9042 19.7167 18 20 18ZM14 26V24.1C14 23.75 14.0875 23.4208 14.2625 23.1125C14.4375 22.8042 14.675 22.5583 14.975 22.375C15.7417 21.925 16.5458 21.5833 17.3875 21.35C18.2292 21.1167 19.1 21 20 21C20.9 21 21.7708 21.1167 22.6125 21.35C23.4542 21.5833 24.2583 21.925 25.025 22.375C25.325 22.5583 25.5625 22.8042 25.7375 23.1125C25.9125 23.4208 26 23.75 26 24.1V26H14ZM20 23C19.3167 23 18.65 23.0833 18 23.25C17.35 23.4167 16.7333 23.6667 16.15 24H23.85C23.2667 23.6667 22.65 23.4167 22 23.25C21.35 23.0833 20.6833 23 20 23ZM12 30C11.45 30 10.9792 29.8042 10.5875 29.4125C10.1958 29.0208 10 28.55 10 28V24H12V28H16V30H12ZM10 16V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10H16V12H12V16H10ZM24 30V28H28V24H30V28C30 28.55 29.8042 29.0208 29.4125 29.4125C29.0208 29.8042 28.55 30 28 30H24ZM28 16V12H24V10H28C28.55 10 29.0208 10.1958 29.4125 10.5875C29.8042 10.9792 30 11.45 30 12V16H28Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                      <div class="tooltip bot">הוסף למערכת PropTech</div>
                    </div>
                    <div class="proptech-texts">זיהוי פנים</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="student-form__ava">
              <div
                class="exit-status-red"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) ===
                  'expired_delay'
                "
              >
                <img class="image-status" src="/images/test-come.svg" />
                <span>חריגה בזמן</span>
              </div>
              <div
                class="exit-status"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) ===
                  'active_use'
                "
              >
                <img src="/images/exit.svg" class="image-status" />
                <span>בחוץ</span>
              </div>
              <div
                class="exit-status-in_campus"
                v-if="
                  findExitPermission(student.exit_permission_user_statuses) !==
                    'active_use' &&
                  findExitPermission(student.exit_permission_user_statuses) !==
                    'expired_delay'
                "
              >
                <img src="/images/inCampus.svg" class="image-status" />
              </div>
              <a
                href="#"
                v-if="
                  user.last_block &&
                  user.last_block !== null &&
                  (user.last_block.is_blocked === 1 ||
                    user.last_block.is_blocked === true)
                "
                class="btn btn--square-md btn--red"
              >
                <icon name="user-block" />
              </a>
              <img
                v-avatar-placeholder
                :src="'/storage/' + user.img"
                alt=""
                :class="{ 'student-form__ava-zoom': !!user.img }"
                :title="user.img ? 'הגדלת התמונה' : null"
                @click="user.img && (photoOpen = true)"
              />
            </div>
            <div class="student-form__rows">
              <div class="student-form__row row-title mb-md-4 mb-4">
                <div v-if="user && user.full_name" class="student-form__wrap">
                  <div class="student-form__title">
                    {{ user.full_name }}
                    <div
                      class="tooltip mr-2"
                      v-if="
                        user.last_block &&
                        user.last_block !== null &&
                        (user.last_block.is_blocked === 1 ||
                          user.last_block.is_blocked === true)
                      "
                    >
                      <div class="tooltip__icon">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8" cy="8" r="8" fill="#FFCC33"></circle>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.5 4L9 4.78349V5V5.21651L8.4996 8.9996H7.4996L7 5.21651V5V4.78349L7.5 4H8.5ZM7.36136 10.7418V11.9996H8.6954V10.7418H7.36136Z"
                            fill="#38455D"
                          ></path>
                        </svg>
                      </div>
                      <div class="tooltip__message">
                        {{ user.last_block.block_user.full_name }}
                        {{ blockDate }}
                      </div>
                    </div>
                  </div>
                  <div class="student-form__post">
                    <div>
                      <span v-if="user.last_activity_at">
                        פעילות אחרונה {{ formatDate(user.last_activity_at) }} ב
                        {{ formatTime(user.last_activity_at) }}
                      </span>
                    </div>
                  </div>
                  <!-- <div class="student-form__last-activity mt-2">
                    <strong>כניסה אחרונה:</strong>
                    {{ formatDateTime(user.last_activity_at) }}
                  </div> -->
                </div>
              </div>
              <div class="student-form__row mb-2 student-tags-row">
                <span
                  v-for="t in selectedStudentTags"
                  :key="t.id"
                  class="student-tags-chip"
                  :style="studentTagChipStyle(t)"
                  :title="t.name"
                >
                  <button
                    type="button"
                    class="student-tags-chip__remove"
                    title="הסר"
                    @click.stop="removeStudentTag(t.id)"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                  <span class="student-tags-chip__text">{{ t.name }}</span>
                </span>
                <button
                  v-if="
                    $perm(
                      'tags.can_use_tags',
                      currentUser.campus_id || selectedCampus?.id
                    )
                  "
                  type="button"
                  class="student-tags-open-btn"
                  @click="openTagsModal"
                >
                  <svg
                    class="student-tags-open-btn__icon"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 5V19M5 12H19"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="student-tags-open-btn__label">הוסף תג </span>
                </button>
              </div>
              <div class="student-form__row">
                <div class="student-form__info">
                  <div class="row row-new">
                    <div class="col-md-5 col-xl-6">
                      <div class="student-form__info-item">
                        <div class="student-form__info-item-title">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22 21H2M4.5 9V21M9.5 9V21M14.5 9V21M19.5 9V21M22 9H2L12 3L22 9Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          class="student-form__info-item-value"
                          v-if="
                            student &&
                            student.user &&
                            student.user.district_administrations
                          "
                        >
                          <span
                            v-for="(adm, index) in student.user
                              .district_administrations"
                            :key="adm.id"
                          >
                            {{ adm.title }}
                            <span
                              v-if="
                                index <
                                student.user.district_administrations.length - 1
                              "
                              >,
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-xl-6">
                      <div class="student-form__info-item new-item">
                        <div class="student-form__info-item-title">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22 21H2M4.5 9V21M9.5 9V21M14.5 9V21M19.5 9V21M22 9H2L12 3L22 9Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div class="student-form__info-item-value">
                          {{
                            student.organization
                              ? student.organization.name
                              : '-'
                          }}
                        </div>
                      </div>
                    </div>

                    <!-- בניין/חדר — третья ячейка ПЕРВОГО ряда грида -->
                    <div class="col-md-5 col-xl-4 student-room-col">
                      <div class="student-form__info-item new-item">
                        <div
                          class="
                            student-form__info-item-value
                            student-room-static
                          "
                        >
                          <span class="student-room-pair">
                            <span class="student-room-label">בניין</span>
                            <span class="student-room-badge">
                              {{
                                student.room && student.room.parent
                                  ? student.room.parent.name
                                  : '-'
                              }}
                            </span>
                          </span>
                          <span class="student-room-pair">
                            <span class="student-room-label">חדר</span>
                            <span class="student-room-badge">
                              {{ student.room ? student.room.name : '-' }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7 col-xl-4">
                      <div class="student-form__info-item">
                        <div class="student-form__info-item-title">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.5 11V17.6574C6.5 17.6574 8.80716 20 12 20C15.1928 20 17.5 17.6574 17.5 17.6574V11M22.5 8.5V13M1.5 8.25L12 4L22.5 8.25L12 12.5L1.5 8.25Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          class="student-form__info-item-value"
                          v-if="
                            student && student.user && student.user.institutions
                          "
                        >
                          <span
                            v-for="(inst, index) in student.user.institutions"
                            :key="inst.id"
                          >
                            {{ inst.title }}
                            <span
                              v-if="
                                index < student.user.institutions.length - 1
                              "
                              >,
                            </span>
                          </span>
                        </div>
                      </div>

                      <div class="student-form__info-item">
                        <div class="student-form__info-item-title">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 3V6M9 3V6M4 9H20M5 5H19C20.1046 5 21 5.79594 21 6.77778V19.2222C21 20.2041 20.1046 21 19 21H5C3.89543 21 3 20.2041 3 19.2222V6.77778C3 5.79594 3.89543 5 5 5Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          class="student-form__info-item-value new-date-block"
                        >
                          {{ formatDate(student.study_start) }} -
                          {{ formatDate(student.study_end) }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-5 col-xl-4">
                      <div class="student-form__post-new new-item">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.8284 15.0544C19.5786 15.7295 20 16.6452 20 17.6V20L19.7611 20.0597C14.6655 21.3336 9.33454 21.3336 4.23886 20.0597L4 20V17.6C4 16.6452 4.42143 15.7295 5.17157 15.0544C5.92172 14.3793 6.93913 14 8 14H16C17.0609 14 18.0783 14.3793 18.8284 15.0544Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11Z"
                              stroke="#5A6F95"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <span>
                          {{ student.status.full_name }}
                        </span>
                      </div>
                      <div class="student-form__info-item new-item">
                        <div class="student-form__info-item-title">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.17157 15.0544L2.50261 14.3111V14.3111L3.17157 15.0544ZM18 20L18.2425 20.9701C18.6877 20.8589 19 20.4589 19 20H18ZM2 20H1C1 20.4589 1.3123 20.8589 1.75746 20.9701L2 20ZM2.23886 20.0597L2.4814 19.0896H2.4814L2.23886 20.0597ZM17.7611 20.0597L17.5186 19.0896V19.0896L17.7611 20.0597ZM21 20C21 20.5523 21.4477 21 22 21C22.5523 21 23 20.5523 23 20H21ZM21.6008 14.7481L22.507 14.3252V14.3252L21.6008 14.7481ZM20.4862 12.1262C20.0036 11.8576 19.3947 12.0312 19.1262 12.5138C18.8576 12.9964 19.0312 13.6053 19.5138 13.8738L20.4862 12.1262ZM17.5631 1.1736C17.1067 0.862618 16.4846 0.980507 16.1736 1.43691C15.8626 1.89332 15.9805 2.51541 16.4369 2.8264L17.5631 1.1736ZM16.4369 9.1736C15.9805 9.48459 15.8626 10.1067 16.1736 10.5631C16.4846 11.0195 17.1067 11.1374 17.5631 10.8264L16.4369 9.1736ZM19 17.6C19 16.344 18.4447 15.1637 17.4974 14.3111L16.1595 15.7977C16.7125 16.2954 17 16.9465 17 17.6H19ZM17.4974 14.3111C16.5536 13.4617 15.2941 13 14 13V15C14.8277 15 15.603 15.2969 16.1595 15.7977L17.4974 14.3111ZM14 13H6V15H14V13ZM6 13C4.70593 13 3.44641 13.4617 2.50261 14.3111L3.84054 15.7977C4.39702 15.2969 5.17233 15 6 15V13ZM2.50261 14.3111C1.55533 15.1637 1 16.344 1 17.6H3C3 16.9465 3.28753 16.2954 3.84054 15.7977L2.50261 14.3111ZM17 17.6V20H19V17.6H17ZM1 17.6V20H3V17.6H1ZM1.75746 20.9701L1.99633 21.0299L2.4814 19.0896L2.24254 19.0299L1.75746 20.9701ZM18.0037 21.0299L18.2425 20.9701L17.7575 19.0299L17.5186 19.0896L18.0037 21.0299ZM1.99633 21.0299C7.25125 22.3436 12.7488 22.3436 18.0037 21.0299L17.5186 19.0896C12.5822 20.3237 7.41784 20.3237 2.4814 19.0896L1.99633 21.0299ZM13.5 6.5C13.5 8.433 11.933 10 10 10V12C13.0376 12 15.5 9.53757 15.5 6.5H13.5ZM10 10C8.067 10 6.5 8.433 6.5 6.5H4.5C4.5 9.53757 6.96243 12 10 12V10ZM6.5 6.5C6.5 4.567 8.067 3 10 3V1C6.96243 1 4.5 3.46243 4.5 6.5H6.5ZM10 3C11.933 3 13.5 4.567 13.5 6.5H15.5C15.5 3.46243 13.0376 1 10 1V3ZM21 18.964V20H23V18.964H21ZM23 18.964C23 17.859 23.0007 16.9752 22.9473 16.2622C22.8933 15.5399 22.7796 14.9095 22.507 14.3252L20.6946 15.1709C20.8212 15.4423 20.9071 15.7998 20.9529 16.4114C20.9993 17.0325 21 17.8288 21 18.964H23ZM19.5138 13.8738C20.0089 14.1493 20.4274 14.5983 20.6946 15.1709L22.507 14.3252C22.0718 13.3925 21.3695 12.6177 20.4862 12.1262L19.5138 13.8738ZM20 6C20 3.99335 19.0523 2.18834 17.5631 1.1736L16.4369 2.8264C17.3446 3.44486 18 4.61155 18 6H20ZM17.5631 10.8264C19.0523 9.81167 20 8.00665 20 6H18C18 7.38845 17.3446 8.55514 16.4369 9.1736L17.5631 10.8264Z"
                              fill="#5A6F95"
                            />
                          </svg>
                        </div>
                        <div class="student-form__info-item-value">
                          {{ student.group ? student.group.name : '' }} /
                          {{
                            student.student_class
                              ? student.student_class.class_name
                              : ''
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- בניין/חדר — отдельный третий столбик, без иконки -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <user-controls
            :block-user="
              user.last_block &&
              user.last_block !== null &&
              (user.last_block.is_blocked === 1 ||
                user.last_block.is_blocked === true)
            "
            classList="col-12 d-flex align-items-center justify-content-center d-xl-none mt-6"
            @unBlockUser="unBlockUser"
            @blockUser="blockUser"
            @changePasswordModal="changePasswordModal = true"
            class=""
          /> -->
        </div>
      </div>
      <StudentChangePassword
        v-if="changePasswordModal"
        @close="changePasswordModal = false"
        :user="user"
      />
    </div>
    <TheConfirm
      :is-shown="isSend"
      title="אזהרה"
      question="האם ברצונך לשלוח פרטי התחברות למערכת למשתמש זה?"
      @ok="sendMessage"
      @cancel="isSend = false"
    />
    <devices-modal
      :is-open="showDevicesModal"
      :devices="userDevices"
      :max-devices="userDevicesMax"
      mode="manage"
      @cancel="showDevicesModal = false"
      @disconnect="onDeviceDisconnect"
    />
    <TagsModal
      :show="showTagsModal"
      :selected-tags="selectedStudentTags"
      :campus-id="selectedCampus && selectedCampus.id"
      @selected-change="onSelectedTagsChange"
      @close="onTagsModalClose"
    />
    <!-- the photo enlarged (click the avatar; click / Esc closes) -->
    <div
      v-if="photoOpen"
      class="ava-lightbox"
      role="dialog"
      aria-label="תמונה"
      @click="photoOpen = false"
    >
      <button
        type="button"
        class="ava-lightbox__close"
        aria-label="סגירה"
        @click.stop="photoOpen = false"
      >
        ×
      </button>
      <img
        v-avatar-placeholder
        :src="'/storage/' + user.img"
        :alt="user.full_name"
        @click.stop
      />
    </div>
  </section>
</template>

<script>
// Packages
import axios from 'axios';
import { mapActions, mapGetters, mapState } from 'vuex';
// import Datepicker from 'vuejs-datepicker';
// import * as lang from 'vuejs-datepicker/src/locale';

import vDatepicker from '@/Components/UI/Form/vDatePicker';
// Validation
import { extend, ValidationObserver } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules.js';
import { setInteractionMode } from 'vee-validate';
import Lang from 'vee-validate/dist/locale/he.json';
// Layouts
import TheConfirm from '@/Components/Alerts/TheConfirm';
import StudentChangePassword from '@/Pages/Student/Blocks/StudentChangePassword';
import SimplePreloader from '@/Components/SimplePreloader.vue';
import CustomThreeSelectVue from '@/Components/UI/Form/CustomThreeSelect.vue';
import TagsModal from '@/Pages/Student/Blocks/Student/TagsModal.vue';
import DevicesModal from '@/Components/Modals/DevicesModal.vue';
// import Modal from '@/Components/Modals/Modal.vue';

const messages = Lang.messages;

setInteractionMode('passive');
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

export default {
  name: 'MainEdit',
  components: {
    ValidationObserver,
    vDatepicker,
    TheConfirm,
    StudentChangePassword,
    SimplePreloader,
    CustomThreeSelectVue,
    TagsModal,
    DevicesModal
    // Modal
  },
  props: {
    user: Object,
    student: Object,
    institutions_ids: Array,
    district_administrations_ids: Array
  },
  data() {
    return {
      isSend: false,
      showDeleteConfirm: false,
      editMode: false,
      language: Lang,
      institutions_ids_data: null,
      district_administrations_ids_data: [],
      imageNotValid: false,
      imageError: 'העלה תמונה',
      imagePreview: '',
      periodNotValid: false,
      periodError: 'חובה למלא את השדה תקופת הלימודים',
      campuses: [],
      statuses: [],
      organizations: [],
      groups: [],
      classes: [],
      user_data: [],
      student_data: [],
      changePasswordModal: false,
      loaderImg: false,
      avatarImgLoaded: false,
      photoOpen: false,
      otherUploadPercentage: 0,
      setNewStudy_start: null,
      study_start: '',
      setNewStudy_end: null,
      study_end: '',
      institutions: [],
      administrations: [],
      isUserInProptech: false,
      checkingProptech: false,
      showProptechDropdown: false,
      showSecurityDropdown: false,
      showDevicesModal: false,
      userDevices: [],
      userDevicesMax: 3,
      showTagsModal: false,
      selectedStudentTags: [],
      tagsAssignSaving: false,
      tagIdsSnapshotBeforeModal: null
      // Google Calendar - temporarily disabled
      // showGoogleCalendarDropdown: false,
      // googleCalendarPermission: 'deny',
      // googleCalendarConnected: false,
      // googleCalendarEmail: '',
      // googleCalendarSaving: false
    };
  },
  computed: {
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    }),
    atLeastOneNotEmpty() {
      return {
        required:
          this.district_administrations_ids_data.length === 0 &&
          this.institutions_ids_data.length === 0
      };
    },
    ...mapGetters({
      currentUser: 'auth/user'
    }),
    blockDate() {
      if (this.user.last_block) {
        return this.$convertDate(this.user.last_block.updated_at, '-', false);
      }
      return false;
    },
    showSendLoginCredentials() {
      // Same rule as the worker card: only for accounts that have not
      // completed their first sign-in (password not personalised yet).
      return !!this.user && Number(this.user.is_first_login) === 1;
    }
  },
  watch: {
    // Esc closes the enlarged photo
    photoOpen(open) {
      if (!this.onPhotoKey) {
        this.onPhotoKey = e => {
          if (e.key === 'Escape') {
            this.photoOpen = false;
          }
        };
      }
      document[open ? 'addEventListener' : 'removeEventListener'](
        'keydown',
        this.onPhotoKey
      );
    },
    institutions_ids_data(val) {
      if (val) {
        // this.student_data.student_class_id = null;
        // this.student_data.student_group_id = null;
        axios
          .get(`/api/campus-classes/${this.selectedCampus.id}`, {
            params: {
              institution_id: this.institutions_ids_data
            }
          })
          .then(res => {
            this.classes = res.data.data;
          });
        axios
          .get(`/api/campus-groups/${this.selectedCampus.id}`, {
            params: {
              institution_id: this.institutions_ids_data
            }
          })
          .then(res => {
            this.groups = res.data.data;
          });
      }
    },
    user_data(val) {
      console.log(val, 'val');
      // if (val?.campus_id) {
      //   axios.get('/api/campus-classes/' + val?.campus_id).then(res => {
      //     this.classes = res.data.data;
      //   });
      //   axios.get('/api/campus-groups/' + val?.campus_id).then(res => {
      //     this.groups = res.data.data;
      //   });
      // }
    },
    student(val) {
      if (val) {
        this.setDefaultDateStart(val.study_start);
        this.setDefaultDateEnd(val.study_end);
      } else {
        return;
      }
    },
    user(val) {
      if (val) {
        this.checkProptechUser();
      } else {
        return;
      }
      if (val.img) {
        this.imagePreview = val.img;
      }
    },
    'student.id': {
      handler(id) {
        if (id) {
          this.loadAssignedStudentTags();
        } else {
          this.selectedStudentTags = [];
        }
      },
      immediate: true
    }
  },
  created() {
    this.user_data = this.user;
    console.log(this.user_data, ' this.user_data');
    this.student_data = this.student;
    this.institutions_ids_data =
      this.institutions_ids.length > 0 ? this.institutions_ids[0] : null;
    this.district_administrations_ids_data = this.district_administrations_ids;
    this.checkProptechUser();
    // this.fetchGoogleCalendarStatus();
    axios
      .get('/api/main-info/institutions', {
        params: {
          short: 1
        }
      })
      .then(res => {
        const array = res.data.data.map(el => {
          return { ...el, label: el.title };
        });
        this.institutions = array;
      });
    axios
      .get('/api/main-info/district-administration', {
        params: {
          short: 1
        }
      })
      .then(res => {
        const array = res.data.data.map(el => {
          return { ...el, label: el.title };
        });
        this.administrations = array;
      });

    axios.get('/api/campuses').then(res => {
      this.campuses = res.data.data;
    });
    axios.get('/api/statuses').then(res => {
      this.statuses = res.data.data;
    });
    console.log(
      'student.exit_permission_user_statuses',
      this.student.exit_permission_user_statuses
    );
    axios.get('/api/organizations').then(res => {
      this.organizations = res.data.data;
      const null_value = {
        id: 0,
        text: '-'
      };
      this.organizations.unshift(null_value);
    });
    if (this.student.user && this.student.user.campus_id) {
      // axios
      //   .get('/api/campus-classes/' + this.student.user.campus_id)
      //   .then(res => {
      //     this.classes = res.data.data;
      //   });
      // axios
      //   .get('/api/campus-groups/' + this.student.user.campus_id)
      //   .then(res => {
      //     this.groups = res.data.data;
      //   });
    }
  },
  methods: {
    mapTagsFromApi(tags) {
      return (Array.isArray(tags) ? tags : []).map(t => ({
        id: t.id,
        name: t.name,
        color_hex: t.color_hex || '',
        category_id: t.category && t.category.id != null ? t.category.id : null
      }));
    },
    async loadAssignedStudentTags() {
      if (!this.student || !this.student.id) {
        this.selectedStudentTags = [];
        return;
      }
      try {
        const r = await axios.get(`/api/tags/students/${this.student.id}/tags`);
        const list = r.data && r.data.tags ? r.data.tags : [];
        this.selectedStudentTags = this.mapTagsFromApi(list);
      } catch (e) {
        this.selectedStudentTags = [];
      }
    },
    async persistStudentTagAssignments() {
      if (!this.student || !this.student.id || this.tagsAssignSaving) {
        return;
      }
      const tag_item_ids = this.selectedStudentTags
        .map(t => Number(t.id))
        .filter(id => Number.isInteger(id) && id > 0);
      this.tagsAssignSaving = true;
      try {
        await axios.put(`/api/tags/students/${this.student.id}/assign-tags`, {
          tag_item_ids
        });
      } catch (e) {
        if (this.$toastr && this.$toastr.e) {
          this.$toastr.e('שגיאה בשמירת התגים');
        }
        await this.loadAssignedStudentTags();
      } finally {
        this.tagsAssignSaving = false;
      }
    },
    sortedTagIdsFromList(list) {
      return (Array.isArray(list) ? list : [])
        .map(t => Number(t && t.id))
        .filter(id => Number.isInteger(id) && id > 0)
        .sort((a, b) => a - b);
    },
    openDevicesModal() {
      this.showSecurityDropdown = false;
      this.fetchUserDevices();
      this.showDevicesModal = true;
    },
    fetchUserDevices() {
      axios
        .get(`/api/users/${this.user.id}/devices`)
        .then(res => {
          this.userDevices = res.data.data;
          this.userDevicesMax = res.data.max_devices;
        })
        .catch(() => {
          this.$toastr.e('שגיאה');
        });
    },
    onDeviceDisconnect(device) {
      axios
        .post(`/api/devices/${device.id}/disconnect`)
        .then(() => {
          this.fetchUserDevices();
        })
        .catch(() => {
          this.$toastr.e('שגיאה');
        });
    },
    openTagsModal() {
      this.tagIdsSnapshotBeforeModal = this.sortedTagIdsFromList(
        this.selectedStudentTags
      );
      this.showTagsModal = true;
    },
    async onTagsModalClose() {
      const before = this.tagIdsSnapshotBeforeModal;
      const after = this.sortedTagIdsFromList(this.selectedStudentTags);
      const same =
        Array.isArray(before) &&
        before.length === after.length &&
        before.every((id, i) => id === after[i]);
      if (!same) {
        await this.persistStudentTagAssignments();
      }
      this.tagIdsSnapshotBeforeModal = null;
      this.showTagsModal = false;
    },
    onSelectedTagsChange(tags) {
      this.selectedStudentTags = Array.isArray(tags) ? tags : [];
    },
    normalizeTagHex(raw) {
      if (!raw || typeof raw !== 'string') {
        return '#E8EEF8';
      }
      let s = raw
        .trim()
        .replace(/^#/, '')
        .replace(/[^0-9A-Fa-f]/g, '');
      if (s.length === 3) {
        s = s
          .split('')
          .map(c => c + c)
          .join('');
      }
      if (s.length < 6) {
        return '#E8EEF8';
      }
      return `#${s.slice(0, 6).toUpperCase()}`;
    },
    isHexColorDark(hex) {
      const h = this.normalizeTagHex(hex);
      const m = /^#([0-9A-F]{6})$/i.exec(h);
      if (!m) {
        return false;
      }
      const n = parseInt(m[1], 16);
      const r = (n >> 16) & 255;
      const g = (n >> 8) & 255;
      const b = n & 255;
      const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return lum < 0.55;
    },
    studentTagChipStyle(t) {
      const bg = this.normalizeTagHex(t && t.color_hex ? t.color_hex : '');
      const dark = this.isHexColorDark(bg);
      return {
        backgroundColor: bg,
        color: dark ? '#ffffff' : '#38455d'
      };
    },
    async removeStudentTag(id) {
      if (id == null || id === '') {
        return;
      }
      const prev = this.selectedStudentTags.slice();
      this.selectedStudentTags = this.selectedStudentTags.filter(
        x => x.id !== id
      );
      if (!this.student || !this.student.id) {
        return;
      }
      try {
        await axios.delete(
          `/api/tags/students/${this.student.id}/unassign-tags/${id}`
        );
      } catch (e) {
        this.selectedStudentTags = prev;
        if (this.$toastr && this.$toastr.e) {
          this.$toastr.e('שגיאה בהסרת התג');
        }
      }
    },
    formatTime(date) {
      if (!date) {
        return '';
      }
      const d = new Date(date);
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    async sendMessage() {
      try {
        const respons = await axios.post('/api/send-user-credentials', {
          email: this.user.email,
          user_type: 'student'
        });
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions({
      updated: 'students/studentUpdated',
      nonUpdated: 'students/studentNotUpdated'
    }),
    changeStudy_start(date) {
      this.student_data.study_start = date;
    },
    changeStudy_end(date) {
      this.student_data.study_end = date;
    },
    deleteTrigger() {
      axios
        .post('/api/students/delete', { students: [this.student.id] })
        .then(res => {
          this.$router.push({
            name: 'StudentList'
          });
          this.$toastr.s('הוסר');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    showDeleteConfirmAction() {
      if (this.page === 'table') {
        const table = this.$refs.studentsTable;
        if (table && table.students_data.map(s => s.selected).some(s => s)) {
          this.showDeleteConfirm = true;
        } else {
          return;
        }
      }
      this.showDeleteConfirm = true;
    },
    formatDate(date) {
      const old_date = new Date(date);
      let month = '' + (old_date.getMonth() + 1);
      let day = '' + old_date.getDate();
      const year = old_date.getFullYear();
      if (day.length < 2) {
        day = '0' + day;
      }
      if (month.length < 2) {
        month = '0' + month;
      }
      const new_date = day + '.' + month + '.' + year;

      return new_date;
    },
    setDefaultDateStart(date) {
      this.student_data.study_start = new Date(date);
    },
    setDefaultDateEnd(date) {
      this.student_data.study_end = new Date(date);
    },
    getDate(date) {
      return new Date(date);
    },
    // setStudyEnd(e) {
    //   const old_date = e;
    //   let month = '' + (old_date.getMonth() + 1);
    //   let day = '' + old_date.getDate();
    //   const year = old_date.getFullYear();
    //   if (day.length < 2) {
    //     day = '0' + day;
    //   }
    //   if (month.length < 2) {
    //     month = '0' + month;
    //   }
    //   const new_date = year + '-' + month + '-' + day;
    //   this.student_data.study_end = new_date;
    // },
    // setStudyStart(e) {
    //   const old_date = e;
    //   let month = '' + (old_date.getMonth() + 1);
    //   let day = '' + old_date.getDate();
    //   const year = old_date.getFullYear();
    //   if (day.length < 2) {
    //     day = '0' + day;
    //   }
    //   if (month.length < 2) {
    //     month = '0' + month;
    //   }
    //   const new_date = year + '-' + month + '-' + day;
    //   this.student_data.study_start = new_date;
    // },
    changeMode(value) {
      this.user_data = this.user;
      this.student_data = this.student;
      this.institutions_ids_data =
        this.institutions_ids.length > 0 ? this.institutions_ids[0] : null;
      this.district_administrations_ids_data =
        this.district_administrations_ids;
      console.log(this.user_data);

      this.editMode = value;
    },
    selectCampus(event) {
      this.student.student_class_id = '';
      this.student.student_group_id = '';
      // axios.get('/api/campus-classes/' + event).then(res => {
      //   this.classes = res.data.data;
      // });
      // axios.get('/api/campus-groups/' + event).then(res => {
      //   this.groups = res.data.data;
      // });
      axios
        .get('/api/classes-in-campus', {
          params: {
            institution_id: this.institutions_ids_data
          }
        })
        .then(res => {
          this.classes = res.data.data;
        });
      axios
        .get('/api/groups-in-campus', {
          params: {
            institution_id: this.institutions_ids_data
          }
        })
        .then(res => {
          this.groups = res.data.data;
        });
    },

    selectFile(event) {
      this.loaderImg = true;
      this.avatarImgLoaded = false;
      this.otherUploadPercentage = 0;
      this.user_data.photo = event.target.files[0];
      const formData = new FormData();
      formData.append('img', this.user_data.photo);
      axios
        .post('/api/user-photo-store', formData, {
          headers: {
            accept: 'application/json',
            'Content-Type': 'multipart/form-data;'
          },
          onUploadProgress: function (progressEvent) {
            const progress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            this.otherUploadPercentage = progress;
          }.bind(this)
        })
        .then(res => {
          this.imagePreview = res.data;
          this.user_data.img = res.data;

          this.imageNotValid = false;
          this.$toastr.s('תמונה הועלתה');
        })
        .catch(err => {
          this.$toastr.e(err.response?.data?.message || 'שגיאה');
        })
        .finally(() => {
          this.loaderImg = false;
          this.avatarImgLoaded = true;
        });
    },

    async saveData() {
      this.nonUpdated();

      const valid = await this.$refs.mainEdit.validate();
      // if (!this.user_data.img) {
      //     this.imageNotValid = true;
      // }
      if (!this.student_data.study_start || !this.student_data.study_end) {
        this.periodNotValid = true;
      } else {
        this.periodNotValid = false;
      }
      if (this.imageNotValid || this.periodNotValid) {
        return;
      }
      const that = this;
      if (valid) {
        axios
          .put('/api/students/' + this.student.id, {
            user: this.user_data,
            student: this.student_data,
            institutions: [this.institutions_ids_data],
            district_administrations: this.district_administrations_ids_data
          })
          .then(res => {
            this.updated();
            this.changeMode(false);
            this.$toastr.s('נשמר');
          })
          .catch(function (err) {
            const errors = err.response.data.errors;
            if (errors) {
              that.$refs.mainEdit.setErrors(errors);
              if (errors['user.img']) {
                that.imageNotValid = true;
                that.imageError = errors['user.img'][0];
              }
              if (errors['student.study_end']) {
                that.periodNotValid = true;
                that.periodError = errors['student.study_end'][0];
              }
              if (errors['student.study_start']) {
                that.periodNotValid = true;
                that.periodError = errors['student.study_start'][0];
              }
            }
            this.$toastr.e('שגיאה');
            // console.log(errors, errors.main, that.$refs.observer);
          });
      }
    },
    blockUser() {
      axios
        .post(`/api/user/${this.user.id}/block`)
        .then(res => {
          this.$emit('update');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    unBlockUser() {
      axios
        .post(`/api/user/${this.user.id}/unblock`)
        .then(res => {
          this.$emit('update');
        })
        .catch(err => {
          this.$toastr.e('שגיאה');
        });
    },
    findExitPermission(exitArray) {
      let status = '';
      if (exitArray.length) {
        const expired = exitArray.findIndex(
          el => el.status === 'expired_delay'
        );
        if (expired == -1) {
          const active = exitArray.findIndex(el => el.status === 'active_use');
          if (active !== -1) {
            status = 'active_use';
          } else {
            status = false;
          }
        } else {
          status = 'expired_delay';
        }
      } else {
        status = false;
      }
      return status;
    },
    /* Google Calendar - temporarily disabled
    toggleGoogleCalendarDropdown() {
      if (!this.showGoogleCalendarDropdown) {
        this.googleCalendarPermission = this.googleCalendarConnected
          ? 'grant'
          : 'deny';
      }
      this.showGoogleCalendarDropdown = !this.showGoogleCalendarDropdown;
    },
    closeGoogleCalendarDropdown() {
      this.showGoogleCalendarDropdown = false;
      this.googleCalendarPermission = this.googleCalendarConnected
        ? 'grant'
        : 'deny';
    },
    async fetchGoogleCalendarStatus() {
      try {
        const { data } = await axios.get('/api/google-calendar/status');
        this.googleCalendarConnected = !!data.connected;
        this.googleCalendarEmail = data.google_email || '';
      } catch (error) {
        this.googleCalendarConnected = false;
        this.googleCalendarEmail = '';
      }
    },
    async saveGoogleCalendarPermission() {
      this.googleCalendarSaving = true;
      try {
        if (this.googleCalendarPermission === 'grant') {
          const { data } = await axios.get('/api/google-calendar/connect');
          if (data.auth_url) {
            window.location.href = data.auth_url;
          }
          return;
        }

        if (this.googleCalendarConnected) {
          await axios.post('/api/google-calendar/disconnect');
        }

        await this.fetchGoogleCalendarStatus();
        this.showGoogleCalendarDropdown = false;
        this.$toastr.s('נשמר');
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'שגיאה';
        this.$toastr.e(message);
      } finally {
        this.googleCalendarSaving = false;
      }
    },
    */
    async checkProptechUser() {
      console.log('Checking PropTech user...', this.user);
      if (!this.user || !this.user.id) {
        return;
      }

      this.checkingProptech = true;
      try {
        const response = await axios.get(
          `/api/proptech/get-person/${this.user.id}`
        );
        // Проверяем count в ответе:
        // count === 0 - пользователя нет в PropTech, показываем кнопку
        // count >= 1 - пользователь есть в PropTech, скрываем кнопку
        const parsedData = JSON.parse(response.data);

        const count = parsedData?.count ?? 0;
        this.isUserInProptech = count >= 1;
      } catch (error) {
        // При ошибке считаем, что пользователя нет в PropTech
        this.isUserInProptech = false;
      } finally {
        this.checkingProptech = false;
      }
    },
    async addUserToProptech() {
      console.log('Adding user to PropTech...');
      if (!this.user || !this.user.id) {
        return;
      }
      console.log('Adding user to PropTech..2.');

      const userData = {
        id: this.user.id.toString(),
        name: this.user.name || ''
        // email: this.user.email || null,
        // gender: this.user.gender || null,
        // date_of_birth: this.user.date_of_birth || null
      };

      // Если есть имя и фамилия, объединяем их
      if (this.user.name && this.user.last_name) {
        userData.name = `${this.user.name} ${this.user.last_name}`;
      } else if (this.user.full_name) {
        userData.name = this.user.full_name;
      }

      // Добавляем entity_id, если он есть
      if (this.user.entity_id) {
        userData.entity_id = this.user.entity_id;
      }

      try {
        const response = await axios.post(
          '/api/proptech/create-person',
          userData
        );
        if (response.status === 200) {
          this.$toastr.s('המשתמש נוסף למערכת PropTech בהצלחה');
          this.isUserInProptech = true;

          // Отправляем ссылку для самостоятельной регистрации
          try {
            await axios.post(
              `/api/proptech/send-self-enrollment-link/${this.user.id}`
            );
          } catch (enrollmentError) {
            console.error(
              'Error sending self-enrollment link:',
              enrollmentError
            );
            // Не показываем ошибку пользователю, так как пользователь уже создан
          }
        }
      } catch (error) {
        console.error('Error adding user to PropTech:', error);
        const errorMessage =
          error.response?.data?.message ||
          'שגיאה בהוספת המשתמש למערכת PropTech';
        this.$toastr.e(errorMessage);
      }
    },
    async sendEnrollmentLink() {
      this.showProptechDropdown = false;

      if (!this.user || !this.user.id) {
        return;
      }

      try {
        const response = await axios.post(
          `/api/proptech/send-self-enrollment-link/${this.user.id}`
        );

        if (response.status === 200) {
          this.$toastr.s('הקישור נשלח בהצלחה');
        }
      } catch (error) {
        console.error('Error sending self-enrollment link:', error);
        const errorMessage =
          error.response?.data?.message || 'שגיאה בשליחת קישור הרשמה עצמית';
        this.$toastr.e(errorMessage);
      }
    },
    async loadUserPhoto() {
      this.showProptechDropdown = false;

      if (!this.user || !this.user.id) {
        return;
      }

      try {
        const response = await axios.post(
          `/api/proptech/generate-self-enrollment-link/${this.user.id}`
        );

        if (response.status === 200 || response.status === 201) {
          // Ответ приходит как строка JSON: "{\"enrollment_link\":\"https://...\"}"
          let responseData = response.data;

          // Если ответ - строка, парсим её
          if (typeof responseData === 'string') {
            try {
              // Парсим JSON строку
              responseData = JSON.parse(responseData);
            } catch (e) {
              console.error('Error parsing response:', e, responseData);
              this.$toastr.e('שגיאה בעיבוד התגובה');
              return;
            }
          }

          // Получаем ссылку из ответа (enrollment_link)
          const enrollmentLink =
            responseData?.enrollment_link ||
            responseData?.link ||
            responseData?.data?.enrollment_link ||
            responseData?.data?.link;

          if (enrollmentLink) {
            // Открываем ссылку в новом окне браузера
            window.open(enrollmentLink, '_blank');
            this.$toastr.s('קישור נפתח בהצלחה');
          } else {
            console.error(
              'Enrollment link not found in response:',
              responseData
            );
            this.$toastr.e('לא נמצא קישור בתגובה');
          }
        }
      } catch (error) {
        console.error('Error loading user photo:', error);
        const errorMessage =
          error.response?.data?.message || 'שגיאה בטעינת תמונת המשתמש';
        this.$toastr.e(errorMessage);
      }
    },
    async deleteUserFromProptech() {
      this.showProptechDropdown = false;

      if (!this.user || !this.user.id) {
        return;
      }

      // Подтверждение удаления
      if (!confirm('האם אתה בטוח שברצונך למחוק את הנתונים ממערכת הזיהוי?')) {
        return;
      }

      try {
        const response = await axios.delete(
          `/api/proptech/delete-person/${this.user.id}`
        );

        if (response.status === 204 || response.status === 200) {
          this.isUserInProptech = false;
          this.$toastr.s('הנתונים נמחקו בהצלחה ממערכת הזיהוי');
        }
      } catch (error) {
        console.error('Error deleting user from PropTech:', error);
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'שגיאה במחיקת הנתונים ממערכת הזיהוי';
        this.$toastr.e(errorMessage);
      }
    }
  }
};
</script>
<style>
.rew-containers {
  padding-left: 24px;
  padding-right: 24px;
}
@media (max-width: 1024px) {
  .rew-containers {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
<style lang="scss" scoped>
.student-form__ava-zoom {
  cursor: zoom-in;
}
.ava-lightbox {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.8);
  cursor: zoom-out;
  img {
    max-width: min(90vw, 720px);
    max-height: 85vh;
    border-radius: 16px;
    object-fit: contain;
    background: #fff;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    cursor: default;
  }
}
.ava-lightbox__close {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.28);
  }
}
.student-form__ava {
  margin-left: 24px !important;
}
.section {
  padding-bottom: 16px !important;
}
.student-form__wrap {
  position: relative;
}
.student-tags-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  width: 100%;
  direction: rtl;
  justify-content: flex-start;
  padding: 4px 0;
}
.student-tags-chip {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  max-width: 220px;
  padding: 6px 12px 6px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  box-sizing: border-box;
  direction: ltr;
}
.student-tags-chip__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.student-tags-chip__remove {
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  flex-shrink: 0;
  opacity: 0.85;
}
.student-tags-chip__remove:hover {
  opacity: 1;
}
.student-tags-open-btn {
  border: 0;
  border-radius: 0;
  background: transparent;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 0;
  flex-shrink: 0;
  color: #409fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  font-family: inherit;
}
.student-tags-open-btn__label {
  white-space: nowrap;
}
.student-tags-open-btn__icon {
  flex-shrink: 0;
  display: block;
}
.student-tags-open-btn:hover {
  color: #2f8eef;
}
.student-tags-open-btn:active {
  color: #2a72c9;
}
.row-new {
  display: grid !important;
  grid-template-columns: repeat(2, 3fr) !important;
  gap: 4px !important;
  column-gap: 52px !important;
}
/* широкие экраны: третья колонка в ряду — под блок בניין/חדר.
   Блоку — span на оба ряда, иначе его высота (две строки бейджей)
   раздувает первый ряд и расталкивает соседние стопки. */
@media (min-width: 1200px) {
  .row-new {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  .student-room-col {
    grid-row: span 2;
    align-self: start;
  }
}
@media (min-width: 767px) {
  .new-item {
    margin-right: 16px;
  }
  .student-form__controls {
    left: 8px !important;
    top: 8px;
  }
}
@media (max-width: 767px) {
  .row-new {
    grid-template-columns: repeat(1, 3fr) !important;
    gap: 4px !important;
  }
}
.student-form__info {
  white-space: nowrap;
}
.new-date-block {
  white-space: nowrap;
  position: relative;
  top: 2px;
}
.student-form__info-item:last-child {
  margin-bottom: 4px !important;
}
.form__body {
  margin-bottom: 0px !important;
}
.form__footer {
  padding-top: 32px;
}
.student-form__controls {
  z-index: 1;
}
@media (min-width: 1024px) {
  .row-title {
    margin-bottom: 24px !important;
  }
  .student-form__post {
    position: absolute;
    top: 30px;
  }
  .student-form__title {
    font-weight: 500;
    font-size: 26px;

    color: #38455d;
  }
}
.student-form__ava img {
  border-radius: 50%;
}
.student-form__ava {
  width: 165px !important;
  height: 165px !important;
}
.student-form__post {
  display: flex;
  gap: 4px;
  font-size: 14px !important;
}

.student-form__info-item-title {
  margin-left: 8px;
}
.student-form__post-new {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
  align-items: flex-end;
}
.student-form__edit-btn {
  position: relative;
}
::v-deep .custom-select .vue-treeselect__single-value {
  font-size: 14px;
  color: black;
  padding-top: 4px;
}
::v-deep .vue-treeselect__single-value {
  right: -9px;
}
.exit-status-red {
  right: 0px;
  display: flex;
  color: rgba(255, 245, 244, 1);
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 1;
  width: 104px;
  font-size: 14px;
  height: 30px;
  background: rgba(255, 96, 82, 1);
  border-radius: 66px;
  padding: 8px;

  img {
    width: 24px;
    height: 24px;
  }
}

.exit-status-in_campus {
  color: rgba(64, 159, 255, 1);
  position: absolute;
  z-index: 1;
}

.exit-status {
  right: 0px;
  display: flex;
  color: rgba(64, 159, 255, 1);
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 1;
  width: 75px;
  height: 30px;
  background: white;
  border-radius: 66px;
  padding-left: 5px;
  padding-right: 5px;

  img {
    width: 30px;
    height: 30px;
  }
}

.student-form__ava {
  position: relative;
}

::v-deep .vue-treeselect__limit-tip-text {
  margin: 2px 0px 0 0 !important;
  color: black;
}

::v-deep .vue-treeselect__input-container {
  margin-top: 4px !important;
}

.custom-select-error {
  border: 1px solid #ff5040;
  border-radius: 4px;
}

::v-deep .custom-select .vue-treeselect__control {
  height: 40px;
  border: 1px solid #cfd3de;
  border-radius: 4px;
  padding: 0 12px;
  background: none;
}

::v-deep .vue-treeselect__x-container {
  // padding-left: 24px;
  // padding-bottom: 1px;
  display: none;
}

.three-select-student-add {
  position: relative;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  margin-bottom: 0;
  flex: 0 0 33%;
  max-width: 33%;
}

.file-inner {
  position: absolute;
  z-index: 3;

  .file-content {
    width: 100%;

    .file-title {
      width: 80%;
      font-size: 9px;
    }
  }
}

.loader-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 2;
}

.hover_upload-new {
  padding: 10px;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.upload-image__img-container:hover {
  .hover_upload-new {
    background-color: #e5f2ff;
    stroke: #409fff;
    opacity: 0.5;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.mainEdit .vdp-datepicker__calendar {
  left: 0;
}

.form__date-inner {
  display: flex;
  align-items: flex-end;
}

.form__date-inner-sep {
  margin-bottom: 12px;
}

.protech-add-btn {
  cursor: pointer;
  // margin-left: 12px;
  position: relative;
  display: flex;
  align-items: center;

  width: 70px;
}
.green-protech {
  transition: 0.3s;
  border-radius: 8px;
  &:hover {
    transform: translateY(-1px) scale(1.02);
    box-shadow: 0 6px 18px rgba(36, 179, 60, 0.18);
  }
}
.orange-protech {
  transition: 0.3s;
  border-radius: 8px;
  &:hover {
    transform: translateY(-1px) scale(1.02);
    box-shadow: 0 6px 18px rgba(255, 193, 7, 0.35);
    filter: saturate(1.1);
  }
}
/* Google Calendar - temporarily disabled
.google-calendar-icon {
  flex-shrink: 0;
  stroke: #5a6f95;
}

.google-calendar-icon--grant {
  stroke: #24b33c;
}

.security-dropdown-item--google-connected .google-calendar-icon {
  stroke: #24b33c;
}

.security-dropdown-google-calendar {
  position: relative;
}

.security-dropdown-google-calendar .protech-dropdown-menu,
.security-dropdown-google-calendar .google-calendar-dropdown-menu {
  position: absolute;
  top: 0;
  right: -231px;
  z-index: 10000;
}

.google-calendar-dropdown {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;
  min-width: 220px;
}

.google-calendar-dropdown__option {
  width: 100%;
}

.google-calendar-dropdown__save {
  align-self: center;
  min-width: 120px;
}

.google-calendar-dropdown-email {
  font-size: 13px;
  color: #5a6f95;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}
*/
.send-block {
  display: flex;
  gap: 8px;
  white-space: nowrap;
  align-items: center;
}
.protech-add-btn-wrapper {
  position: relative;
  // margin-left: 12px;
}
.delete-send-text {
  color: #fd1500;
}
.dropdown-arrow {
  transition: transform 0.2s ease;
}
.student-form__controls {
  gap: 12px;
}
.dropdown-arrow--open {
  transform: rotate(180deg);
}

.protech-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  overflow: hidden;
}

.protech-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #38455d;
  transition: background-color 0.2s ease;
}

.protech-dropdown-item:hover {
  background-color: #f5f7fa;
}

.protech-dropdown-item:not(:last-child) {
  border-bottom: 1px solid #e3e7ee;
}
@media (max-width: 1180px) {
  .protech-dropdown-menu {
    left: 0;
    right: auto;
  }
}

.security-select-wrapper {
  position: relative;
}
::v-deep .user-line {
  display: none;
}

.security-select-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #38455d;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.proptech-texts {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;

  color: #38455d;
}
.email-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;

  color: #38455d;
}
.security-dropdown-item {
  border-radius: 4px;
}
.security-dropdown-item:hover {
  transition: 0.3s;

  background: #e5f2ff !important;
}

.security-select-btn:hover {
  background: #e8ecf1;
  border-color: #cfd3de;
}

.security-select-btn svg:first-of-type {
  margin-right: 0;
}

.security-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: -90px;
  background: white;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1;
  min-width: 220px;
  /* overflow: hidden; */
  display: block;
  padding: 8px;
}

.security-menu-controls {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  // padding: 8px 0;
}

.security-menu-controls .btn {
  margin: 4px 12px;
  width: auto;
}

.security-menu-controls .sep-line {
  display: none;
}

.security-dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;

  cursor: pointer;
  font-size: 14px;
  color: #38455d;
  transition: background-color 0.2s ease;
}

// .security-dropdown-item:hover {
//   background-color: #f5f7fa;
// }

// .security-dropdown-item:not(:last-child) {
//   border-bottom: 1px solid #e3e7ee;
// }

.security-dropdown-item icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

::v-deep .security-dropdown-item icon svg {
  width: 20px;
  height: 20px;
}

.security-dropdown-item--separator {
  padding: 0;
  cursor: default;
}

.security-dropdown-item--separator:hover {
  background-color: transparent;
}

.security-dropdown-separator {
  height: 1px;
  background-color: #e3e7ee;
  margin: 8px 0;
}

.security-dropdown-protech {
  position: relative;
  padding: 0;
  padding-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.security-dropdown-protech .protech-dropdown-menu {
  position: absolute;
  top: 0px;
  right: -231px;
  z-index: 10000;
}

@media (max-width: 1180px) {
  .security-dropdown-menu {
    left: 0;
    right: auto;
  }

  .security-dropdown-protech .protech-dropdown-menu {
    right: auto;
    left: calc(100% + 8px);
  }

  /* .security-dropdown-google-calendar .protech-dropdown-menu {
    right: auto;
    left: calc(100% + 8px);
  } */
}
@media (max-width: 480px) {
  .redact-text {
    display: none;
  }
  .dropdawn-info-text {
    display: none;
  }
  .security-dropdown-protech .protech-dropdown-menu {
    right: -10px !important;
    top: 51px !important;
    left: auto !important;
  }

  /* .security-dropdown-google-calendar .protech-dropdown-menu {
    right: -10px !important;
    top: 51px !important;
    left: auto !important;
  } */
}

/* בניין/חדר ученика — стиль бейджей как в личном деле работника */
/* третий столбик в ряду (xl-4): пары держим у правого края колонки,
   столбиком друг под другом */
.student-room-col {
  .student-room-static {
    flex-direction: column;
    align-items: flex-end;
  }
}
.student-room-static {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  direction: rtl;
}
.student-room-pair {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.student-room-label {
  font-size: 13px;
  color: #5a6f95;
  white-space: nowrap;
}
.student-room-badge {
  background: #1b2337;
  color: #fff;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
</style>
